import Nullstack from 'nullstack';
export default function IconDiscGolf({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-disc-golf",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 5h14"
  }), "   ", Nullstack.element("path", {
    d: "M6 5c.32 6.744 2.74 9.246 6 10"
  }), "   ", Nullstack.element("path", {
    d: "M18 5c-.32 6.744 -2.74 9.246 -6 10"
  }), "   ", Nullstack.element("path", {
    d: "M10 5c.006 4.915 .552 7.082 2 10"
  }), "   ", Nullstack.element("path", {
    d: "M14 5c-.006 4.915 -.552 7.082 -2 10"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v6"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M7 16c.64 .64 1.509 1 2.414 1h5.172c.905 0 1.774 -.36 2.414 -1"
  }), "   ", Nullstack.element("path", {
    d: "M11 21h2"
  }), " ");
}